import httpClient from './httpClient';

const add_comment = (comment) => httpClient.post('/api/td_comment',comment);
const delete_comment = (id) => httpClient.delete('/api/td_comment/'+id);
const mark_as_read = (id) => httpClient.put('/api/td_comment/mark_as_read/'+id);
export {
    add_comment,
    delete_comment,
    mark_as_read
}